import { Phone, MessageSquare, MapPin, ShieldCheck, Clock } from "lucide-react";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pt-12 pb-16 sm:pt-20 sm:pb-24">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          {/* Copy column */}
          <div className="lg:col-span-7">
            <div className="fade-in-up inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm">
              <MapPin className="w-4 h-4 text-[#D97706]" />
              Serving Perth's north-western suburbs
            </div>

            <h1 className="fade-in-up delay-100 mt-6 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-slate-900 leading-[1.05]">
              Friendly, local tech support
              <span className="block rainbow-text">you can trust.</span>
            </h1>

            <p className="fade-in-up delay-200 mt-6 text-lg sm:text-xl text-slate-700 leading-relaxed max-w-2xl">
              Simple advice, fair prices, no jargon. Daz comes to your home or
              office to fix tech troubles — patient with seniors, fast for
              businesses, kind to everyone.
            </p>

            <div className="fade-in-up delay-300 mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="tel:0409049094"
                data-testid="hero-call-button"
                className="inline-flex items-center justify-center gap-2 h-14 px-7 rounded-xl bg-[#1E56B8] hover:bg-[#2E6BD9] text-white font-semibold text-lg shadow-md hover:-translate-y-0.5 transition-all"
              >
                <Phone className="w-5 h-5" strokeWidth={2.25} />
                Call 0409 049 094
              </a>
              <a
                href="#enquiry"
                data-testid="hero-enquiry-button"
                className="inline-flex items-center justify-center gap-2 h-14 px-7 rounded-xl bg-white border-2 border-slate-900 text-slate-900 font-semibold text-lg hover:bg-slate-900 hover:text-white transition-all"
              >
                <MessageSquare className="w-5 h-5" strokeWidth={2.25} />
                Send an Enquiry
              </a>
            </div>

            <div className="fade-in-up delay-400 mt-10 flex flex-wrap gap-x-8 gap-y-3 text-sm text-slate-700">
              <span className="inline-flex items-center gap-2">
                <ShieldCheck className="w-5 h-5 text-[#16A34A]" />
                Honest, no-jargon advice
              </span>
              <span className="inline-flex items-center gap-2">
                <Clock className="w-5 h-5 text-[#16A34A]" />
                Same-week appointments
              </span>
              <span className="inline-flex items-center gap-2">
                <ShieldCheck className="w-5 h-5 text-[#16A34A]" />
                Free for eligible seniors
              </span>
            </div>
          </div>

          {/* Image column */}
          <div className="lg:col-span-5">
            <div className="fade-in-up delay-200 relative">
              <div className="absolute -inset-4 -z-10 rounded-[2rem] bg-gradient-to-br from-[#D97706]/15 via-transparent to-[#1E56B8]/10 blur-2xl" />
              <div className="relative rounded-3xl overflow-hidden border border-slate-200 shadow-xl bg-white">
                <img
                  src="https://images.pexels.com/photos/8439743/pexels-photo-8439743.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                  alt="A friendly tech helper assisting a senior with a laptop"
                  className="w-full h-[420px] sm:h-[520px] object-cover"
                  loading="eager"
                />
              </div>
              {/* Floating trust badge */}
              <div className="absolute -bottom-5 -left-5 sm:-left-8 bg-white border border-slate-200 rounded-2xl shadow-lg px-5 py-4 flex items-center gap-3">
                <div className="h-12 w-12 rounded-xl bg-[#D97706]/15 flex items-center justify-center">
                  <ShieldCheck className="w-6 h-6 text-[#D97706]" />
                </div>
                <div>
                  <div className="text-sm text-slate-500 font-medium">A real local</div>
                  <div className="font-[Outfit] text-lg font-semibold text-slate-900">Just one call away</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
